import { toast } from "react-toastify";
import { executePost } from "../ServiceMethods";
import { removeUserCredentials } from "../LocalStorage";
import { SessionTimeout } from "../ErrorMessages";

export const DeleteCardApi = async (data, cb) => {
  try {
    const DeleteCard = await executePost(
      "/businessuser/deleteBusinessCards",
      data
    );
    const DeleteCardData = DeleteCard.data ? DeleteCard.data : {};
    return DeleteCardData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
